import { render } from "./NoticePage.vue?vue&type=template&id=c3d48232"
import script from "./NoticePage.vue?vue&type=script&lang=js"
export * from "./NoticePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__